interface PaginatedResult<TData> {
  data: TData[];
  hasNext?: boolean;
  hasPrevious?: boolean;
  next?: string;
  previous?: string;
}

/**
 * Execute the callback function and continue fetching the next page until there are no more pages.
 */
export async function fetchAllPages<
  TData,
  TResult extends PaginatedResult<TData>,
>(callback: (next?: string) => Promise<TResult>): Promise<TResult> {
  let data: TData[] = [];
  let curNext: string | undefined = undefined;
  const pagesLimit = 50;
  for (let i = 0; i < pagesLimit; i++) {
    const response = await callback(curNext);
    data = [...data, ...response.data];
    if (!response.hasNext) {
      break;
    }
    curNext = response.next;
  }
  return {
    data,
    hasPrevious: false,
    hasNext: false,
  } as TResult;
}
